module.exports = __webpack_public_path__ + "static/media/producthunt.7eb928e1.svg";